<template>
  <Modal :black="true" classes="full transparent modal--signature" @close="emitClose">
      <div class="portrait">
        <p>
          Моля, завъртете устройството си в пейзажен режим, за да може да се
          подпишете
        </p>
      </div>

      <button class="modal__close" type="button" @click="emitClose">×</button>
      <p class="danger">
        Поставете ръчно вашите име и подпис, като изписвате старателно буквите.
        <br />
        Не излизайте от жълтия правоъгълник. Ако сгрешите, изберете бутона
        Направи отново.
      </p>
      <div class="signature-canvas">
        <canvas ref="signCanvas"></canvas>
      </div>
      <footer class="buttons">
        <button class="btn danger" type="button" @click="clear">Направи отново</button>
        <button class="btn save" type="button" @click="save">Потвърди подпис</button>
      </footer>
  </Modal>
</template>

<script>
import Modal from "../components/Modal.vue";

export default {
  name: "SignatureModal",
  components: {
    Modal,
  },
  props: {
    signature: String,
  },
  data() {
    return {
      signCanvas: null,
      signatureLoaded: false,
      isDrawing: false,
      isSignatureEmpty: true,
      lastPoint: null,
      currentWidth: (window.innerWidth / 100) * 98,
      ratio: Math.max(window.devicePixelRatio || 1, 1),
    };
  },
  mounted() {
    this.signCanvas = this.$refs.signCanvas;
    this.prepareCanvas();
    this.currentWidth = this.signCanvas.offsetWidth;
    this.addCanvasListeners();
    window.addEventListener("resize", this.resize);

    if (this.signature) {
      const image = new Image();
      image.onload = () => {
        this.drawSignatureImage(image);
        this.signatureLoaded = true;
        this.isSignatureEmpty = false;
      };
      image.src = this.signature;
    }
  },
  beforeDestroy() {
    this.removeCanvasListeners();
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    emitClose() {
      this.$emit("close");
    },
    drawSignatureImage(image) {
      const context = this.signCanvas.getContext("2d");
      context.save();
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.clearRect(0, 0, this.signCanvas.width, this.signCanvas.height);
      context.drawImage(
        image,
        0,
        0,
        this.signCanvas.width,
        this.signCanvas.height
      );
      context.restore();
    },
    prepareCanvas() {
      this.ratio = Math.max(window.devicePixelRatio || 1, 1);
      const width = this.signCanvas.offsetWidth;
      const height = this.signCanvas.offsetHeight;
      this.signCanvas.width = width * this.ratio;
      this.signCanvas.height = height * this.ratio;
      const context = this.signCanvas.getContext("2d");
      context.scale(this.ratio, this.ratio);
      context.lineCap = "round";
      context.lineJoin = "round";
      context.lineWidth = 4;
      context.strokeStyle = "#000";

      if (!this.signature) {
        this.clear();
      }
    },
    clear() {
      const context = this.signCanvas.getContext("2d");
      context.save();
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.clearRect(0, 0, this.signCanvas.width, this.signCanvas.height);
      context.restore();
      this.signatureLoaded = false;
      this.isSignatureEmpty = true;
      this.lastPoint = null;
    },
    addCanvasListeners() {
      this.signCanvas.addEventListener("mousedown", this.startDrawing);
      this.signCanvas.addEventListener("mousemove", this.draw);
      window.addEventListener("mouseup", this.stopDrawing);
      this.signCanvas.addEventListener("touchstart", this.startDrawing, { passive: false });
      this.signCanvas.addEventListener("touchmove", this.draw, { passive: false });
      window.addEventListener("touchend", this.stopDrawing);
    },
    removeCanvasListeners() {
      this.signCanvas.removeEventListener("mousedown", this.startDrawing);
      this.signCanvas.removeEventListener("mousemove", this.draw);
      window.removeEventListener("mouseup", this.stopDrawing);
      this.signCanvas.removeEventListener("touchstart", this.startDrawing);
      this.signCanvas.removeEventListener("touchmove", this.draw);
      window.removeEventListener("touchend", this.stopDrawing);
    },
    getPoint(event) {
      const source = event.touches ? event.touches[0] : event;
      const rect = this.signCanvas.getBoundingClientRect();
      return {
        x: source.clientX - rect.left,
        y: source.clientY - rect.top,
      };
    },
    startDrawing(event) {
      event.preventDefault();
      this.isDrawing = true;
      this.lastPoint = this.getPoint(event);
      this.signatureLoaded = false;
    },
    draw(event) {
      if (!this.isDrawing) return;
      event.preventDefault();
      const point = this.getPoint(event);
      const context = this.signCanvas.getContext("2d");
      context.beginPath();
      context.moveTo(this.lastPoint.x, this.lastPoint.y);
      context.lineTo(point.x, point.y);
      context.stroke();
      this.lastPoint = point;
      this.isSignatureEmpty = false;
    },
    stopDrawing() {
      this.isDrawing = false;
      this.lastPoint = null;
    },
    resize() {
      const dataUrl = this.isSignatureEmpty ? "" : this.signCanvas.toDataURL("image/png");
      this.prepareCanvas();

      if (dataUrl) {
        const image = new Image();
        image.onload = () => {
          this.drawSignatureImage(image);
          this.isSignatureEmpty = false;
        };
        image.src = dataUrl;
      }
    },
    save() {
      const isEmpty = this.isSignatureEmpty && !this.signatureLoaded;

      if (isEmpty) {
        this.$snotify.error("Не може да запазите празен подпис");
        return;
      }

      const dataUrl = this.signCanvas.toDataURL("image/png");
      const hasChanged = dataUrl !== this.signature;

      this.$emit("signed", dataUrl, hasChanged);
      this.emitClose();
    },
  },
};
</script>

<style lang="scss">
.modal-wrapper {
  .modal.modal--signature {
    align-items: center;
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    user-select: none;

    .modal__close {
      background: transparent;
      border: none;
      color: #ffffb8;
      cursor: pointer;
      font-size: 36px;
      line-height: 1;
      padding: 8px;
      position: absolute;
      right: 18px;
      top: 14px;
      z-index: 2;

      &:hover {
        background-color: rgba($color: #ffffb8, $alpha: 0.2);
      }
    }

    > .danger {
      color: #ffffb8;
      font-size: 14px;
      margin: 18px 0;
      text-align: center;
    }

    .signature-canvas {
      background-color: #ffffb8;
      height: 23.7576vw;
      width: 98vw;

      canvas {
        height: 100%;
        touch-action: none;
        width: 100%;
      }
    }

    .portrait {
      display: none;
    }

    footer {
      display: flex;
      gap: 10px;
      justify-content: flex-end;
      padding: 12px 1vw 0;
      width: 100%;

      .btn {
        border: none;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
        font-weight: 700;
        padding: 10px 18px;
      }

      .danger {
        background: #bf392a;
      }

      .save {
        background: #479538;
      }
    }
  }
}

@media screen and (max-width: 768px) and (orientation: portrait) {
  .modal-wrapper .modal--signature {
    justify-content: center;

    .portrait {
      align-items: center;
      background-color: #000;
      color: #ffffb8;
      display: flex;
      flex-direction: column;
      gap: 20px;
      height: 100%;
      justify-content: center;
      left: 0;
      padding: 0 10px;
      position: fixed;
      text-align: center;
      top: 0;
      width: 100%;
      z-index: 1;

      > p {
        color: #ffffb8;
        font-size: 1rem;
        opacity: 0.8;
      }
    }
  }
}
</style>
